<template>
	<table class="table" id="table_bet_report">
		<thead></thead>
		<tbody></tbody>
		<tfoot></tfoot>
	</table>
</template>
<script>
	import { Utilities } from "../../utilities";

	export default {
		props: ['data'],
		data() {
			return {
				"child": "",
				"current": "",
			}
		},
		watch:{
	    	data: function(d){
		    	if ($.fn.DataTable.isDataTable('#table_bet_report')){
				 	$('#table_bet_report').DataTable().destroy();
				 	$('#table_bet_report tfoot').html("");
				}

				if(this.$route.params.code == "admin"){
					this.child = "Nhà cái";
					this.current = "Admin";
				}else{
					switch(this.$route.params.code.length){
						case 1:
							this.child = "Super";
							this.current = "Nhà cái";
							break;
						case 3:
							this.child = "Master";
							this.current = "Super";
							break;
						case 5:
							this.child = "Đại lý";
							this.current = "Master";
							break;
						case 7:
							this.child = "Hội viên";
							this.current = "Đại lý";
							break;
					}
				}

				if(this.$route.path.indexOf('bet-raw') != -1){
					if(this.$route.params.code.length == 9){
						this.buildTableSmsRaw(d);
					}else{
						this.buildTableBetRaw(d);
					}
				}else{
					if(this.$route.params.code.length == 9){
						this.buildTableSms(d);
					}else{
						this.buildTableBet(d);
					}
				}
	    	}
		},
		methods: {
			buildTableBetRaw: function(d){
	        	let vm = this;
				var html = "";
				for(let i in d){
					var r = d[i];
					html += "<tr>"+
								"<td><a class='code'>"+r.code.toUpperCase()+"</a></td>"+
								"<td>"+r.full_name+"</td>"+
								"<td class='right'>"+r.total_bet+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.bet_amount)+"</td>"+
							"</tr>";
				}

	        	$("#table_bet_report thead").html("<tr>"+
													"<th>Tài khoản</th>"+
													"<th>Tên</th>"+
													"<th>Số cược</th>"+
													"<th>Tiền xác</th>"+
													"<th>Thực thu</th>"+
												"</tr>");
	        	$("#table_bet_report tbody").html(html);
	        	if(html != "") vm.buildBetRawSummaryFooter(d);
				$("#table_bet_report").DataTable({
											aaSorting: [],
											responsive: false,
						            		pagingType: "full_numbers",
								            searching: false,
								            dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
										});

				$(document).off("click", "#table_bet_report .code");
				$(document).on("click", "#table_bet_report .code", function(){
					let level = $(this).html();
					let router = {name: 'BetReportTotalRaw', params: { code: level } };
					vm.$router.push(router);
				});
			},
			buildTableSmsRaw: function(d){
	        	let vm = this;
				var html = "";
				for(let i in d){
					var r = d[i];
					var remove = r.status == -1 ? "remove" : "";
					html += "<tr class='"+remove+"'>"+
								"<td class='left'><a class='sms' sid='"+r.sms_id+"'>"+r.sms+"</a></td>"+
								"<td class='right'>"+r.bet_count+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.bet_amount)+"</td>"+
								"<td>"+moment(r.sms_created_at, "YYYY-MM-DD HH:mm:ss.u").format("YYYY-MM-DD HH:mm:ss")+"</td>"+
							"</tr>";
				}

	        	$("#table_bet_report thead").html("<tr>"+
													"<th>Sms</th>"+
													"<th class='right'>Số cược</th>"+
													"<th class='right'>Tiền xác</th>"+
													"<th class='right'>Thực thu</th>"+
													"<th>Thời gian</th>"+
												"</tr>");
	        	$("#table_bet_report tbody").html(html);
	        	if(html != "") vm.buildSmsRawSummaryFooter(d);
				$("#table_bet_report").DataTable({
											aaSorting: [],
											responsive: false,
						            		pagingType: "full_numbers",
								            searching: false,
								            dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
										});

				$(document).off("click", "#table_bet_report .sms");
				$(document).on("click", "#table_bet_report .sms", function(){
					let sms_id = $(this).attr("sid");
					let router = {name: 'BetReportDetailRaw', params: { code: vm.$route.params.code, smsId: sms_id } };
					vm.$router.push(router);
				});
			},
			buildBetRawSummaryFooter: function(d){
				let vm = this;
				let total_bet = d.reduce((total, currentValue) => { return total+currentValue.total_bet; }, 0);
				let bet_amount = d.reduce((total, currentValue) => { return total+currentValue.bet_amount; }, 0);
				let turn_over = d.reduce((total, currentValue) => { return total+currentValue.turn_over; }, 0);

				var html = "<tr>"+
								"<td>Tổng cộng</td>"+
								"<td></td>"+
								"<td class='right'>"+total_bet+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(bet_amount)+"</td>"+
							"</tr>";

	        	$("#table_bet_report tfoot").html(html);
			},
			buildSmsRawSummaryFooter: function(d){
				let vm = this;
				let bet_count = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.bet_count; }, 0);
				let turn_over = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.turn_over; }, 0);
				let bet_amount = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.bet_amount; }, 0);
				

				var html = "<tr>"+
								"<td>Tổng cộng</td>"+
								"<td class='right'>"+Utilities.formatNumber(bet_count)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(bet_amount)+"</td>"+
								"<td></td>"+
							"</tr>";

	        	$("#table_bet_report tfoot").html(html);
			},
			buildTableBet: function(d){
	        	let vm = this;
				var html = "";
				for(let i in d){
					var r = d[i];
					html += "<tr>"+
								"<td><a class='code'>"+r.code.toUpperCase()+"</a></td>"+
								"<td>"+r.full_name+"</td>"+
								"<td class='right'>"+r.total_bet+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.bet_amount)+"</td>"+
								"<td class='right'>"+vm.reportColor(r.member_pay)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.net_amount)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.margin)+"</td>"+
								"<td class='right'>"+vm.reportColor(r.salePay)+"</td>"+
								"<td class='right'>"+vm.reportColor(r.billing)+"</td>"+
							"</tr>";
				}

	        	$("#table_bet_report thead").html("<tr>"+
													"<th rowspan='2'>Tài khoản</th>"+
													"<th rowspan='2' class='no-sort'>Tên</th>"+
													"<th rowspan='2' class='no-sort'>Số cược</th>"+
													"<th rowspan='2' class='no-sort'>Tiền xác</th>"+
													"<th rowspan='2' class='no-sort'>Tiền cược</th>"+
													"<th rowspan='2'>"+vm.child+" thanh toán</th>"+
													"<th colspan='3'>Thông tin "+vm.current+"</th>"+
													"<th rowspan='2'>Thanh toán</th>"+
												"</tr>"+
												"<tr>"+
													"<th class='right' class='no-sort'>Chung</th>"+
													"<th class='right' class='no-sort'>Cò</th>"+
													"<th class='right'>PM kế toán</th>"+
												"</tr>");
	        	$("#table_bet_report tbody").html(html);
	        	if(html != "") vm.buildBetSummaryFooter(d);
				$("#table_bet_report").DataTable({
											aaSorting: [],
											responsive: false,
						            		pagingType: "full_numbers",
								            searching: false,
								            dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
										});

				$(document).off("click", "#table_bet_report .code");
				$(document).on("click", "#table_bet_report .code", function(){
					let level = $(this).html();
					let router = {name: 'BetReportTotal', params: { code: level } };
					vm.$router.push(router);
				});
			},
			buildTableSms: function(d){
	        	let vm = this;
				var html = "";
				for(let i in d){
					var r = d[i];
					var remove = r.status == -1 ? "remove" : "";
					html += "<tr class='"+remove+"'>"+
								"<td class='left'><a class='sms' sid='"+r.sms_id+"'>"+r.sms+"</a></td>"+
								"<td class='right'>"+r.bet_count+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.bet_amount)+"</td>"+
								"<td class='right'>"+vm.reportColor(r.winloss)+"</td>"+
								"<td>"+moment(r.sms_created_at, "YYYY-MM-DD HH:mm:ss.u").format("YYYY-MM-DD HH:mm:ss")+"</td>"+
							"</tr>";
				}

	        	$("#table_bet_report thead").html("<tr>"+
													"<th>Sms</th>"+
													"<th class='right'>Số cược</th>"+
													"<th class='right'>Tiền xác</th>"+
													"<th class='right'>Thực thu</th>"+
													"<th class='right'>Thắng / Thua</th>"+
													"<th>Thời gian</th>"+
												"</tr>");
	        	$("#table_bet_report tbody").html(html);
	        	if(html != "") vm.buildSmsSummaryFooter(d);
				$("#table_bet_report").DataTable({
											aaSorting: [],
											responsive: false,
						            		pagingType: "full_numbers",
								            searching: false,
								            dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
										});

				$(document).off("click", "#table_bet_report .sms");
				$(document).on("click", "#table_bet_report .sms", function(){
					let sms_id = $(this).attr("sid");
					let router = {name: 'BetReportDetail', params: { code: vm.$route.params.code, smsId: sms_id } };
					vm.$router.push(router);
				});
			},
			buildBetSummaryFooter: function(d){
				let vm = this;
				let total_bet = d.reduce((total, currentValue) => { return total+currentValue.total_bet; }, 0);
				let turn_over = d.reduce((total, currentValue) => { return total+currentValue.turn_over; }, 0);
				let bet_amount = d.reduce((total, currentValue) => { return total+currentValue.bet_amount; }, 0);
				let winloss = d.reduce((total, currentValue) => { return total+currentValue.winloss; }, 0);
				let member_pay = d.reduce((total, currentValue) => { return total+currentValue.member_pay; }, 0);
				let net_amount = d.reduce((total, currentValue) => { return total+currentValue.net_amount; }, 0);
				let margin = d.reduce((total, currentValue) => { return total+currentValue.margin; }, 0);
				let billing = d.reduce((total, currentValue) => { return total+currentValue.billing; }, 0);
				let salePay = d.reduce((total, currentValue) => { return total+currentValue.salePay; }, 0);

				var html = "<tr>"+
								"<td>Tổng cộng</td>"+
								"<td></td>"+
								"<td class='right'>"+total_bet+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(bet_amount)+"</td>"+
								"<td class='right'>"+vm.reportColor(member_pay)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(net_amount)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(margin)+"</td>"+
								"<td class='right'>"+vm.reportColor(salePay)+"</td>"+
								"<td class='right'>"+vm.reportColor(billing)+"</td>"+
							"</tr>";

	        	$("#table_bet_report tfoot").html(html);
			},
			buildSmsSummaryFooter: function(d){
				let vm = this;
				let bet_count = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.bet_count; }, 0);
				let turn_over = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.turn_over; }, 0);
				let bet_amount = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.bet_amount; }, 0);
				let winloss = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.winloss; }, 0);
				

				var html = "<tr>"+
								"<td>Tổng cộng</td>"+
								"<td class='right'>"+bet_count+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(bet_amount)+"</td>"+
								"<td class='right'>"+vm.reportColor(winloss)+"</td>"+
								"<td></td>"+
							"</tr>";

	        	$("#table_bet_report tfoot").html(html);
			},
			reportColor: function(value){
				let color = value >= 0 ? 'blue' : 'red';
    			return "<span style='color:"+color+";'>" + Utilities.currencyFormat(value) + "</span>";
			}
		}
	}
</script>

<style>
	.left{
	    text-align: left;
	}
</style>